export const MATTER_SETTLEMENT_MONEY_STATUS_OPTIONS = [
  "Not Received",
  "Pending",
  "Received",
  "Partially Deposited",
  "Deposited",
] as const;
